import { TextField, Select, MenuItem, Box, Typography, ButtonBase, Grid } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

const RAPPORTO_OPTIONS = ['Banca', 'Posta', 'Nessuno'];
const CARTA_OPTIONS = ['Visa', 'Mastercard', 'American Express', 'Bancomat', 'Nessuna Carta'];

export default function Step11SocioDemografico({ data, onChange, errors }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Nucleo familiare e rapporti bancari
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Qualche informazione in più sulla tua situazione
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Numero familiari" error={errors?.numero_familiari} completed={!!data.numero_familiari} hint="Incluso te stesso">
            <TextField fullWidth size="small" type="number" inputProps={{ min: 1 }} value={data.numero_familiari || ''} onChange={e => onChange('numero_familiari', parseInt(e.target.value) || '')} placeholder="Es. 3" />
          </FieldWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <FieldWrapper label="Familiari con reddito" error={errors?.familiari_con_reddito} completed={!!data.familiari_con_reddito}>
            <TextField fullWidth size="small" type="number" inputProps={{ min: 0 }} value={data.familiari_con_reddito || ''} onChange={e => onChange('familiari_con_reddito', parseInt(e.target.value) || '')} placeholder="Es. 2" />
          </FieldWrapper>
        </Grid>
      </Grid>

      <FieldWrapper label="Rapporti banca / posta" error={errors?.rapporto_banca_posta} completed={!!data.rapporto_banca_posta}>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {RAPPORTO_OPTIONS.map(opt => (
            <ButtonBase
              key={opt}
              onClick={() => onChange('rapporto_banca_posta', opt)}
              sx={{
                flex: 1,
                py: 1.5,
                px: 2,
                borderRadius: 2,
                fontSize: '0.875rem',
                fontWeight: 500,
                border: '2px solid',
                transition: 'all 0.2s',
                borderColor: data.rapporto_banca_posta === opt ? 'primary.main' : 'divider',
                bgcolor: data.rapporto_banca_posta === opt ? 'primary.light' : 'transparent',
                color: data.rapporto_banca_posta === opt ? 'primary.main' : 'text.secondary',
                '&:hover': { borderColor: 'primary.main' }
              }}
            >
              {opt}
            </ButtonBase>
          ))}
        </Box>
      </FieldWrapper>

      {data.rapporto_banca_posta && data.rapporto_banca_posta !== 'Nessuno' && (
        <FieldWrapper label="Cliente dal (mese/anno)" error={errors?.anzianita_banca} completed={!!data.anzianita_banca}>
          <TextField fullWidth size="small" type="month" InputLabelProps={{ shrink: true }} value={data.anzianita_banca || ''} onChange={e => onChange('anzianita_banca', e.target.value)} />
        </FieldWrapper>
      )}

      <FieldWrapper label="Carta di credito" error={errors?.carta_credito} completed={!!data.carta_credito}>
        <Select 
          fullWidth 
          size="small" 
          value={data.carta_credito || ''} 
          onChange={e => onChange('carta_credito', e.target.value)}
          displayEmpty
        >
          <MenuItem value="" disabled>Seleziona tipo carta</MenuItem>
          {CARTA_OPTIONS.map(opt => (
            <MenuItem key={opt} value={opt}>{opt}</MenuItem>
          ))}
        </Select>
      </FieldWrapper>
    </Box>
  );
}